export enum FixedShape {
    Rectangle = "Rectangle"
}